export default class Validator {
    constructor() {
        this.decimalSeparator = '.';
    }

    zipcode(value) {

    }
}
